import React, {Fragment, PropsWithChildren} from "react";
import {Header} from "views/components/header/header.component";
import {Footer} from "views/components/footer/footer.component";
import {MainBox} from "views/components/style";

interface IProps extends PropsWithChildren {
	withBg?: boolean;
	bgStyle?: boolean;
	isResulted?: boolean;
	isShowLoginAlert?: boolean;
	className?: string;
}

export const HocLayout: React.FC<IProps> = ({
	children,
	withBg = false,
	bgStyle = false,
	isResulted = false,
	isShowLoginAlert = false,
	className,
}) => {
	return (
		<Fragment>
			<Header isShowLoginAlert={isShowLoginAlert} />
			<MainBox
				$withBg={withBg}
				$bgStyle={bgStyle}
				$isResulted={isResulted}
				className={className}>
				{children}
			</MainBox>
			<Footer />
		</Fragment>
	);
};
